import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-tipo-residuos-categoria',
  templateUrl: './tipo-residuos-categoria.component.html',
  styleUrls: ['./tipo-residuos-categoria.component.css']
})
export class TipoResiduosCategoriaComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
